import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API } from "@/lib/api";
import { reviewValidationError } from "@/lib/formHelpers";
import { useVisitor } from "./useVisitor";

export const useReviewForm = (onAdded) => {
  const [name, setName] = useState("");
  const [service, setService] = useState("autre");
  const [rating, setRating] = useState(5);
  const [hover, setHover] = useState(0);
  const [comment, setComment] = useState("");
  const [sending, setSending] = useState(false);
  const { visitor, logout } = useVisitor();

  const submit = async (event) => {
    event.preventDefault();
    const error = reviewValidationError(name, comment, visitor);
    if (error) { toast.error(error); return; }
    setSending(true);
    try {
      const payload = { name: visitor?.first_name || name.trim(), service, rating, comment: comment.trim() };
      const { data } = await axios.post(`${API}/reviews`, payload, { withCredentials: true });
      onAdded(data);
      setName(""); setComment(""); setRating(5); setService("autre");
      toast.success(data.verified ? "Merci ! Ton avis vérifié est publié." : "Merci pour ton avis !");
    } catch { toast.error("Impossible d'envoyer l'avis, réessaie"); }
    finally { setSending(false); }
  };

  return { name, setName, service, setService, rating, setRating, hover, setHover, comment, setComment, sending, visitor, logout, submit };
};